import { createSlice, PayloadAction } from "@reduxjs/toolkit/react"
import { GenesisCareImportRecord } from "./Integrations.GenesisCare.Client"

const generateRandomInteger = (max: number) => (Math.floor(Math.random() * max))

const formatRecordId = (recordIdNumber: number, recordIdDate: Date): string => {
    const datePart = recordIdDate.toISOString().split("T")[0]

    return `GC${recordIdNumber}_${datePart}`
}

// TODO: BESH: CORE-10205 Add other fields from specification
const createEmptyRecord = (): GenesisCareImportRecord => ({
    record_id: "",
    record_date: ""
})

// TODO: BESH: CORE-10205 Add other fields from specification
const createRecord = (recordNumber: number, recordDate: Date): GenesisCareImportRecord => ({
    record_id: formatRecordId(recordNumber, recordDate),
    record_date: recordDate.toISOString()
})

const initial = {
    showAddRecord: false,
    lastRecordNumber: 1,
    newRecord: createEmptyRecord(),
    editingRecordJson: false,
    recordJson: "",
}

const genesisCareIntegrationSlice = createSlice({
    name: "genesisCareIntegration",
    initialState: initial,
    reducers: {
        setShowAddRecord: (state, action: PayloadAction<boolean>) => {
            state.showAddRecord = action.payload
        },
        setRecord: (state, action: PayloadAction<GenesisCareImportRecord>) => {
            state.newRecord = action.payload
        },
        nextRecord: (state) => {
            const recordNumber = state.lastRecordNumber + 1
            const recordDate = new Date()

            state.lastRecordNumber = recordNumber
            state.newRecord = createRecord(recordNumber, recordDate)
            state.recordJson = ""
            state.editingRecordJson = false
        },
        clearRecord: (state) => {
            state.lastRecordNumber = 1
            state.newRecord = createEmptyRecord()
            state.recordJson = ""
        },
        randomiseRecord: (state) => {
            const recordNumber = generateRandomInteger(999999)
            const recordDate = new Date()

            state.lastRecordNumber = recordNumber
            state.newRecord = createRecord(recordNumber, recordDate)
            state.recordJson = ""
        },
        editRecordJson: (state) => {
            state.editingRecordJson = true
            state.recordJson = JSON.stringify([state.newRecord], null, 2)
        },
        cancelEditRecordJson: (state) => {
            state.editingRecordJson = false
            state.recordJson = ""
        },
        setJsonRecord: (state, action: PayloadAction<string>) => {
            state.recordJson = action.payload
        }
    },
    selectors: {
        showAddRecord: (s) => s.showAddRecord,
        newRecord: (s) => s.newRecord,
        recordJson: (s) => s.recordJson,
        editingRecordJson: (s) => s.editingRecordJson
    }
})

export default genesisCareIntegrationSlice
